import { RacwaStandardPageTemplateProps, theme } from "@racwa/react-components";
import { useLocation } from "react-router-dom";
import { UtilityPageHeading, utilityRoutes } from "../../routing/routes.config";
import usePage from "../usePage";

export const useStandardPage = (): RacwaStandardPageTemplateProps => {
  const location = useLocation();
  const commonPageProps = usePage();

  const currentStandardPageRoute = utilityRoutes.find(
    (route) => route.path.toLowerCase() === location.pathname.toLowerCase(),
  );

  const heading = currentStandardPageRoute?.heading ?? "";

  const useYellowHeading = heading === UtilityPageHeading.RetrieveQuote;

  return {
    heading,
    bannerTextColour: useYellowHeading ? theme.palette.primary.main : theme.palette.common.white,
    navBreadcrumbProps: commonPageProps.responsiveHeaderProps?.NavBreadcrumbsProps,
    ...commonPageProps,
  };
};

export default useStandardPage;
